import {createListSearchOrderItem, ListSearchOrderByItem, orderByAlphabetPipe} from "orpyx-web-common";
import {GetPatientsListPropertyOrderBy} from "doctors-dashboard/http-clients/index";

export const PatientsListOrderPipe = (order: GetPatientsListPropertyOrderBy, orderByAsc?: boolean): string => {
    switch (order) {
        case GetPatientsListPropertyOrderBy.LastReviewDate:
            return 'Last Review Date';
        case GetPatientsListPropertyOrderBy.FirstName:
            return orderByAlphabetPipe('First name', orderByAsc);
        case GetPatientsListPropertyOrderBy.LastName:
            return orderByAlphabetPipe('Last name', orderByAsc);
        case GetPatientsListPropertyOrderBy.ClientPatientIdentifier:
            return 'Patient ID';
        case GetPatientsListPropertyOrderBy.DateOfPatientAuthorization:
            return 'Patient Initialization Date';
        case GetPatientsListPropertyOrderBy.LastStatusUpdatedAt:
            // Ascending (oldest status-change date first) surfaces patients waiting longest in their
            // pinned status - i.e. the least recently changed - first.
            return orderByAsc ? 'Status Last Changed (Least Recent First)' : 'Status Last Changed (Most Recent First)';
    }
    return `Unknown: ${order}`;
};

// Shared by every tab except Active: none of them display a "days since last review" /
// LastReviewDate column, so it's deliberately omitted here - see ActivePatientsListOrderPipeItems.
export const PatientsListOrderPipeItems: ListSearchOrderByItem[] = [
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.FirstName, PatientsListOrderPipe, true),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.FirstName, PatientsListOrderPipe, false),

    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.LastName, PatientsListOrderPipe, true),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.LastName, PatientsListOrderPipe, false),

    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.ClientPatientIdentifier, PatientsListOrderPipe, true),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.DateOfPatientAuthorization, PatientsListOrderPipe, true),
];

// Active is the only tab with a "Days Since Last Review" column, so it's the only one offered
// LastReviewDate as a sort option.
export const ActivePatientsListOrderPipeItems: ListSearchOrderByItem[] = [
    // The API and this pipe both speak in terms of the raw LastReviewDate, but the table displays
    // its inverse: "days since last review". Sorting the date ascending (oldest date first) is what
    // surfaces the LEAST recently reviewed patients first - the intended default - even though the
    // boolean below reads as "ascending" rather than "least recent first".
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.LastReviewDate, PatientsListOrderPipe, true),
    ...PatientsListOrderPipeItems,
];

// Inactive is the only tab with a "Status Last Changed" column, so it's the only one offered
// LastStatusUpdatedAt as a sort option. Both directions are offered explicitly (rather than a
// clickable column-header arrow) so the meaning of each direction can be spelled out in its label.
export const InactivePatientsListOrderPipeItems: ListSearchOrderByItem[] = [
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.LastStatusUpdatedAt, PatientsListOrderPipe, true),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.LastStatusUpdatedAt, PatientsListOrderPipe, false),
    ...PatientsListOrderPipeItems,
];

